/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./VListItem.vue?vue&type=template&id=5d0a8de6"
import script from "./VListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./VListItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VListItem.vue?vue&type=style&index=0&id=5d0a8de6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports